import translation from 'locales/translation';
import {
  Col,
  Collapse,
  Modal,
  ModalSizes,
  Row,
} from 'plataforma-fundacao-componentes';

import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import { AssemblyModalities } from 'helpers/enums/Assembleia';
import { getApis } from 'library/Apis';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useCallback, useEffect, useState } from 'react';
import './styles.scss';

interface IProps extends ModalProps {
  applicationId: AssemblyModalities | null;
  eventId: number;
  cpfCnpj?: string;
}

enum EventType {
  COOP_PONTA_LAPIS = 1,
  ASSEMBLEIAS_DIGITAL = 2,
  ASSEMBLEIAS_PRESENCIAL = 3,
  ASSEMBLEIAS_SEMIPRESENCIAL = 4,
}

export const SatisfactionSurvey = (props: IProps) => {
  const [load, setLoad] = useState<boolean>(true);
  const [thanksMessage, setThanksMessage] = useState<boolean>(false);

  const mapApplicationIdToEventType = (
    applicationId: AssemblyModalities | null
  ): EventType | null => {
    switch (applicationId) {
      case 'OFFLINE':
        return EventType.ASSEMBLEIAS_PRESENCIAL;
      case 'ONLINE':
        return EventType.ASSEMBLEIAS_DIGITAL;
      case 'HIBRIDO_PRESENCIAL_DIGITAL':
      case 'HIBRIDO_SIMULTANEO':
      case 'HIBRIDO_DIGITAL_AGENCIA':
        return EventType.ASSEMBLEIAS_SEMIPRESENCIAL;
      default:
        return EventType.COOP_PONTA_LAPIS;
    }
  };

  const param = props.cpfCnpj
    ? `${mapApplicationIdToEventType(props.applicationId)}/${props.eventId}/${
        props.cpfCnpj
      }`
    : `${mapApplicationIdToEventType(props.applicationId)}/${props.eventId}`;
  const encode = btoa(param);

  const handleClose = useCallback(() => {
    props.onClose?.(props.modalKey);
  }, [props]);

  useEffect(() => {
    const f = (e: { data: string }) => {
      if (e.data === 'finished') {
        setThanksMessage(true);

        setTimeout(() => {
          handleClose();
        }, 8000);

        setTimeout(() => {
          setThanksMessage(false);
        }, 9000);
      }
    };

    window.addEventListener('message', f);

    return () => {
      window.removeEventListener('message', f);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window]);

  const selector = document.getElementById('survey-modal');

  let height = selector && selector?.getBoundingClientRect().height - 55;

  return (
    <Modal
      title={translation.Associado.Modal.SatisfactionSurvey.title}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={props.onClose}
      size={ModalSizes.ExtraLarge}
      className={'root'}
      id={'survey-modal'}
    >
      <Collapse opened={thanksMessage} animateOpacity>
        <div className={'bar'}>
          <div
            className={'fill'}
            onAnimationEnd={() => {
              if (typeof props.onClose === 'function') props.onClose();
            }}
          />
        </div>
      </Collapse>
      <Collapse opened={!thanksMessage && load} animateOpacity>
        <Loading inline backgroundTransparent />
      </Collapse>
      <Collapse opened={!thanksMessage} animateOpacity>
        <div
          style={{
            width: '100%',
            height: '525px',
            transition: '0.5s ease-in-out',
            opacity: load ? '0' : '1',
            overflowY: 'hidden',
          }}
        >
          <iframe
            title={'Pesquisa de satisfação'}
            src={`${getApis().links.pesquisa}/${encode}?embed=true`}
            style={{
              border: '0',
            }}
            name={'satisfactionSurvey'}
            width={'100%'}
            height={load ? '0px' : `${height}px`}
            onLoad={() =>
              setTimeout(() => {
                setLoad(false);
              }, 500)
            }
          />
        </div>
      </Collapse>
      <Collapse opened={thanksMessage} animateOpacity>
        <Row className={'message'}>
          <Col centralized>
            <svg
              width='104'
              height='105'
              viewBox='0 0 104 105'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M104 52.9917C104 24.2724 80.7193 0.991699 52 0.991699C23.2807 0.991699 0 24.2724 0 52.9917C0 61.8253 2.20665 70.343 6.35679 77.9258C9.54632 83.7521 13.8306 88.9223 18.9572 93.1455C28.1969 100.759 39.7741 104.992 52 104.992C80.7193 104.992 104 81.711 104 52.9917ZM2 52.9917C2 25.377 24.3853 2.9917 52 2.9917C79.6147 2.9917 102 25.377 102 52.9917C102 80.6064 79.6147 102.992 52 102.992C40.2424 102.992 29.1138 98.9226 20.2289 91.6019C15.2985 87.5403 11.1781 82.5679 8.11116 76.9655C4.12119 69.6753 2 61.4875 2 52.9917ZM35.1114 33.9584C30.9897 33.9584 27.6484 37.2997 27.6484 41.4214C27.6484 41.9737 27.2007 42.4214 26.6484 42.4214C26.0961 42.4214 25.6484 41.9737 25.6484 41.4214C25.6484 36.1951 29.8851 31.9584 35.1114 31.9584C40.3377 31.9584 44.5744 36.1951 44.5744 41.4214C44.5744 41.9737 44.1267 42.4214 43.5744 42.4214C43.0221 42.4214 42.5744 41.9737 42.5744 41.4214C42.5744 37.2997 39.2331 33.9584 35.1114 33.9584ZM68.8888 33.9584C64.7671 33.9584 61.4258 37.2997 61.4258 41.4214C61.4258 41.9737 60.9781 42.4214 60.4258 42.4214C59.8735 42.4214 59.4258 41.9737 59.4258 41.4214C59.4258 36.1951 63.6625 31.9584 68.8888 31.9584C74.1151 31.9584 78.3518 36.1951 78.3518 41.4214C78.3518 41.9737 77.9041 42.4214 77.3518 42.4214C76.7995 42.4214 76.3518 41.9737 76.3518 41.4214C76.3518 37.2997 73.0105 33.9584 68.8888 33.9584ZM41.7251 82.0351C56.2186 86.3736 71.4855 78.1406 75.8233 63.6474C75.9816 63.1183 76.5389 62.8177 77.068 62.9761C77.5971 63.1344 77.8977 63.6917 77.7393 64.2208C73.0849 79.7723 56.7033 88.6064 41.1515 83.9511C40.6224 83.7927 40.3219 83.2354 40.4803 82.7063C40.6387 82.1772 41.196 81.8767 41.7251 82.0351Z'
                fill='#3FA110'
              />
            </svg>
            <h1>{translation.Associado.Modal.SatisfactionSurvey.thanks}</h1>
            <p>
              {translation.Associado.Modal.SatisfactionSurvey.betterAssembly}
            </p>
          </Col>
        </Row>
      </Collapse>
    </Modal>
  );
};
